import styled from 'styled-components';

export const InputContainer = styled.div`
  /* position: relative; */
  display: flex;
  flex-direction: column;
  width: 100%;
  /* margin-block: ${({ theme }) => theme.spacing.l}; */

  input,
  textarea,
  select {
    min-width: 100%;
    padding: ${({ theme }) => theme.spacing.s};
    border: 1.5px solid ${({ theme }) => theme.colors.grey2};
    border-radius: ${({ theme }) => theme.borderRadius};
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.grey6};
    box-shadow: 0 1px 3px ${({ theme }) => theme.colors.grey1}22;
    transition:
      border-color 0.2s,
      box-shadow 0.2s;
    /* border: 5px solid red; */

    &:hover {
      border-color: ${({ theme }) => theme.colors.orange1};
      box-shadow: 0 2px 8px ${({ theme }) => theme.colors.grey2}22;
    }

    &:focus {
      border-color: ${({ theme }) => theme.colors.yellow5};
      box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.yellow4}55;
      outline: none;
    }
  }

  label {
    color: ${({ theme }) => theme.colors.grey5};
    transition: all 0.3s ease;
    font-weight: 700;
    margin-bottom: ${({ theme }) => theme.spacing.xs};
    /* border: 1px solid red; */
  }

  .detail {
    color: ${({ theme }) => theme.colors.grey4};
    margin-left: ${({ theme }) => theme.spacing.xxs};
  }

  @media screen and (max-width: 650px) {
    margin-bottom: ${({ theme }) => theme.spacing.m};
  }
`;

export const TagContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xxs};
  width: 100%;
  /* justify-content: center; */
  flex-wrap: wrap;
  /* border: 1px solid green; */
  background-color: ${({ theme }) => theme.colors.offWhite};
  padding: ${({ theme }) => theme.spacing.s};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-top: ${({ theme }) => theme.spacing.xl};
`;
export const EachTag = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
  /* gap: ${({ theme }) => theme.spacing.m}; */
  padding: ${({ theme }) => theme.spacing.xxs};
  width: calc(50% - 4rem);
  label {
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey5};
  }
`;

export const ArrayContainer = styled.div`
  margin-block: ${({ theme }) => theme.spacing.m};
  padding-block: ${({ theme }) => theme.spacing.m};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
  .mappedElements {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xxs};
  }
  .inputDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.xl};
    margin-block: ${({ theme }) => theme.spacing.m};
  }
  input {
    width: 70%;
  }
  h4 {
    margin-bottom: ${({ theme }) => theme.spacing.m};
    /* border-bottom: 1px solid ${({ theme }) => theme.colors.grey}; */
    //text-transform: uppercase;
  }
`;
